import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ParticipantId } from 'src/app/components/participant/store/participant.model';

@Component({
  selector: 'app-side-navigation-submenu-participant',
  templateUrl: './side-navigation-submenu-participant.component.html',
  styleUrls: ['./side-navigation-submenu-participant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavigationSubmenuParticipantComponent implements OnInit {
  tooltipDelay: number = 0.5;

  @Input() collapse: boolean = true;
  @Input() theme: string = 'light';
  @Input() participant: ParticipantId | any;
  @Output() select = new EventEmitter<string>(false);
  constructor() {}

  ngOnInit(): void {}

  onSelect(event: string): void {
    if (!event) return;
    this.select.emit(event);
  }
}
